export const SUPPORT_EMAIL = "hello@ernest-app.com";

export type AccountRequestKind = "details" | "team" | "plan" | "delete";

export interface AccountContext {
  name?: string;
  email?: string;
  company?: string;
}

const REQUESTS: Record<AccountRequestKind, { subject: string; ask: string; fill: string }> = {
  details: {
    subject: "Update my account details",
    ask: "I'd like to update my account details.",
    fill: "What I'd like to change:",
  },
  team: {
    subject: "Add or update a team member",
    ask: "I'd like to add or update a team member.",
    fill: "Name, work email and role of the person:",
  },
  plan: {
    subject: "Plan and billing change",
    ask: "I'd like to change my plan or billing details.",
    fill: "What I'd like to change:",
  },
  delete: {
    subject: "Account deletion request",
    ask: "Please delete my account and the data linked to it. I understand this cannot be undone.",
    fill: "Anything you should know before you delete it:",
  },
};

/** A pre-written email to the team for an account change, so the user only has to press send. */
export function buildAccountMailto(kind: AccountRequestKind, ctx: AccountContext = {}): string {
  const r = REQUESTS[kind];
  const account = [ctx.name, ctx.email, ctx.company].filter(Boolean).join(", ");
  const body = [
    "Hi ernest team,",
    "",
    r.ask,
    "",
    r.fill,
    "",
    "",
    account ? `My account: ${account}` : "",
    "",
    "Thanks.",
  ].join("\n");
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(r.subject)}&body=${encodeURIComponent(body)}`;
}
